<template>
  <div class="app-layout">
    <navigation-menu
      :menu-items="menuItems"
      :selected-id="currentMenuId"
      :logo-text="'LMIS'"
      :user-info="userInfo"
      @select="handleMenuSelect"
      @user-command="handleUserCommand"
    />

    <div class="app-content">
      <div class="app-header">
        <el-tabs
          v-model="activeTab"
          type="card"
          closable
          @tab-remove="handleTabRemove"
          @tab-click="handleTabClick"
        >
          <el-tab-pane
            v-for="tab in tabs"
            :key="tab.path"
            :label="tab.label"
            :name="tab.path"
          >
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="router-view-wrapper">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      currentMenuId: 'cost-bill-check',
      activeTab: '/cost-bill-check',
      tabs: [
        { label: '车辆监控', path: '/vehicle-monitor/data' },
        { label: '成本账单核对', path: '/cost-bill-check' }
      ],
      menuItems: [
        {
          id: 'basic-data',
          label: '基础资料',
          icon: 'el-icon-folder',
          children: [
            {
              id: 'network-point',
              label: '网点信息管理',
              path: '/network-point/list'
            },
            {
              id: 'user-account',
              label: '账号信息管理',
              path: '/user-account/list'
            }
          ]
        },
        {
          id: 'settlement-management',
          label: '结算管理',
          icon: 'el-icon-document',
          children: [
            {
              id: 'cost-bill-check',
              label: '成本账单核对',
              path: '/cost-bill-check'
            },
            {
              id: 'cost-diff-rule',
              label: '成本差异规则',
              path: '/cost-diff-rule'
            },
            {
              id: 'cost-diff-handle',
              label: '成本差异处理',
              path: '/cost-diff-handle'
            }
          ]
        },
        {
          id: 'warehouse-management',
          label: '仓储管理',
          icon: 'el-icon-building',
          children: [
            {
              id: 'warehouse-list',
              label: '仓库列表',
              path: '/warehouse/list'
            },
            {
              id: 'zone-management',
              label: '园区管理',
              path: '/warehouse/zone'
            }
          ]
        },
        {
          id: 'transport-management',
          label: '运输管理',
          icon: 'el-icon-truck',
          children: [
            {
              id: 'vehicle-monitor',
              label: '车辆监控',
              path: '/vehicle-monitor/data'
            },
            {
              id: 'alert-config',
              label: '预警配置',
              path: '/vehicle-monitor/alert-config'
            },
            {
              id: 'inbound-plan',
              label: '入库计划管理',
              path: '/vehicle-monitor/inbound-plan-management'
            }
          ]
        },
        {
          id: 'contract-management',
          label: '合同管理',
          icon: 'el-icon-file-text'
        },
        {
          id: 'log-query',
          label: '日志查询',
          icon: 'el-icon-search'
        }
      ],
      userInfo: {
        name: 'Admin',
        avatar: '',
        commands: [
          { label: '个人设置', value: 'settings' },
          { label: '退出登录', value: 'logout' }
        ]
      }
    }
  },
  methods: {
    handleMenuSelect(item) {
      this.currentMenuId = item.id
      if (item.path) {
        const existingTab = this.tabs.find(tab => tab.path === item.path)
        if (!existingTab) {
          this.tabs.push({ label: item.label, path: item.path })
        }
        this.activeTab = item.path
        this.$router.push(item.path)
      }
    },
    handleTabRemove(path) {
      const index = this.tabs.findIndex(tab => tab.path === path)
      if (index > -1) {
        this.tabs.splice(index, 1)
        if (this.activeTab === path) {
          this.activeTab = this.tabs.length > 0 ? this.tabs[0].path : '/'
          this.$router.push(this.activeTab)
        }
      }
    },
    handleTabClick(tab) {
      this.$router.push(tab.name)
    },
    handleUserCommand(command) {
      if (command === 'logout') {
        console.log('退出登录')
      } else if (command === 'settings') {
        console.log('个人设置')
      }
    }
  }
}
</script>

<style>
.app-layout {
  display: flex;
  height: 100vh;
}

.app-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.router-view-wrapper {
  flex: 1;
  overflow-y: auto;
}

.app-header {
  background: white;
  border-bottom: 1px solid #e4e7ed;
}

.app-header .el-tabs--card {
  border: none;
}

.app-header .el-tabs__header {
  margin: 0;
  border-bottom: 1px solid #e4e7ed;
}

.app-header .el-tabs__nav {
  padding: 0 20px;
}

.app-header .el-tabs__item {
  height: 48px;
  line-height: 48px;
  padding: 0 20px;
  font-size: 14px;
}

.app-header .el-tabs__item.is-active {
  color: #409EFF;
}

.app-header .el-tabs__active-bar {
  height: 2px;
}
</style>